export const Rights = [
    "WEB_MODULE_SETTINGS_PILOT_TRANSPORT_CONTACT_WRITE"
]
